const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/courses/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { settingsHomeRoutes } from "@circle-react/lib/routes/settingsHome";
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/courses")({
  beforeLoad: () => {
    const isCircleV4 = Boolean(window.V4_UI);
    if (!isCircleV4) {
      redirect({
        to: settingsHomeRoutes.index.path,
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});